// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"1278":"4-auth-msal","6252":"3-render-apperrorrenderer","49751":"4-auth-naa","56613":"4-feat-app-error","57798":"4-feat-protobuf-request","57935":"4-feat-thirdpartycookies","67299":"4-feat-report-one-ds-event","83660":"2-polyfill-idle","87116":"4-feat-initialize-one-ds"}[chunkId] || chunkId) + ".js";
};